import { validateEmailField } from '../../../Core/Helpers/emailValidation';

export default (values) => {

  const errors = {}

  // Validate required fields
  if (!values.to || (Array.isArray(values.to) && values.to.length === 0)) {
    errors.to = 'At least one recipient is required';
  } else {
    const toError = validateEmailField(values.to);
    if (toError) errors.to = toError;
  }

  if (!values.subject || !values.subject.trim()) {
    errors.subject = 'Subject is required';
  }

  if (!values.body || !values.body.trim()) {
    errors.body = 'Body is required';
  }

  // Validate optional email fields
  if (values.cc) {
    const ccError = validateEmailField(values.cc);
    if (ccError) errors.cc = ccError;
  }

  if (values.bcc) {
    const bccError = validateEmailField(values.bcc);
    if (bccError) errors.bcc = bccError;
  }

  return errors

}
